import { useApplicationTriggerFlow } from '@/components/Functional/hooks-core/useApplicationTriggerFlowStateMachine'
import { useCampaignSlug } from '@/components/Functional/hooks-core/useCampaignSlug'
import { DialogNearbySpots } from '@/components/Layout/DialogNearbySpots'
import { BottomNavigation as BottomNavigationUI } from '@/components/UI/BottomNavigation'
import type { BottomNavigationProps as UIProps } from '@/components/UI/BottomNavigation'
import { useRouter } from 'next/router'
import { memo, useCallback } from 'react'

export type BottomNavigationProps = Pick<UIProps, 'activeItem' | 'onItemClick' | 'showStamp'>

export const BottomNavigation = memo(function BottomNavigation(props: BottomNavigationProps) {
  const trigger = useApplicationTriggerFlow()
  const router = useRouter()
  const { gen } = useCampaignSlug()

  const handleSelectSpot = useCallback(
    (spotId: number) => {
      trigger.selectSpot(spotId)
      router.push({ pathname: gen('/spots/detail'), query: { id: spotId } })
    },
    [trigger, router, gen],
  )

  return (
    <>
      <BottomNavigationUI {...props} onApplicationTriggerClick={trigger.trigger} />
      <DialogNearbySpots
        opened={trigger.isSelectingSpot}
        onClose={trigger.closeDialog}
        nearbySpots={trigger.nearbySpots}
        isAllQrCampaign={false}
        onSelect={handleSelectSpot}
        gpsAvailable={trigger.gpsAvailable}
      />
    </>
  )
})
